import { ThemedSkeleton } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { useFeatureFlag } from '../../../contexts/FeatureFlagContext';
import { floatingTabbarScrollBottomPad } from '../../../helpers/floatingTabbarLayout';

export const ProfilePageSkeleton: FC = () => {
    const rewardsEnabled = useFeatureFlag('rewards');

    return (
        <Stack
            sx={{
                position: 'relative',
                height: '100%',
                overflow: 'hidden',
                bgcolor: 'var(--tg-theme-secondary-bg-color)',
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    inset: 0,
                    overflow: 'hidden',
                    pt: 'calc(var(--tg-viewport-safe-area-inset-top, 0px) + 5px)',
                    px: 2,
                    pb: floatingTabbarScrollBottomPad,
                }}
            >
                <Stack alignItems="center" spacing={0.75} sx={{ pb: 2 }}>
                    <ThemedSkeleton variant="circular" width={96} height={96} />
                    <ThemedSkeleton variant="text" width={130} height={22} />
                    <ThemedSkeleton variant="text" width={90} height={16} />
                </Stack>
                <Stack spacing={1}>
                    {[0, 1, ...(rewardsEnabled ? [2] : []), 3].map(index => (
                        <ThemedSkeleton key={index} variant="rectangular" width="100%" height={66} sx={{ borderRadius: '12px' }} />
                    ))}
                </Stack>
            </Box>
        </Stack>
    );
};
